import { clsx } from 'clsx';
import { useLocation } from 'react-router-dom';

import { GenericInfo } from './Content/GenericInfo';
import styles from './SidePanel.module.css';
import SidePanelLoader from './SidePanelLoader';
import { useLocale } from '../../hooks/useLocale';
import { useSignupParams } from '../../hooks/useSignupParams';
import { useGetBrandingQuery } from '../../lendingApi/lendingApiQueries';
import PoweredByIwoca from '../PoweredByIwoca/PoweredByIwoca';
import TrustPilot from '../TrustPilot/TrustPilot';
import { OpenBankingFAQ } from './Content/OpenBankingFAQ';
import { UK_DIRECT_BASE_OB_LINK_PATHNAME } from '../../constants';
import useWindowDimensions from '../../hooks/useWindowDimensions';

const SidePanel = () => {
  const { isPartnerCustomer, isDirectCustomer } = useSignupParams();
  const { isUK } = useLocale();
  const { pathname } = useLocation();
  const { isMobile } = useWindowDimensions();

  const { branding, isBrandingLoading } = useGetBrandingQuery();

  const isOBShareableLinkPage = pathname.includes(
    UK_DIRECT_BASE_OB_LINK_PATHNAME,
  );

  const trustPilotTheme =
    branding?.data?.secondary_theme === 'light' ? 'light' : 'dark';

  const whiteIwocaLogo =
    Boolean(branding?.data?.iwoca_logo_colour === 'white') ||
    isDirectCustomer ||
    isOBShareableLinkPage;

  return (
    <div
      className={clsx(styles.container, {
        [styles.loading]: isPartnerCustomer && isBrandingLoading,
      })}
    >
      {isPartnerCustomer && isBrandingLoading ? (
        <SidePanelLoader />
      ) : (
        <>
          <div>
            {isOBShareableLinkPage && isUK ? (
              <OpenBankingFAQ />
            ) : (
              <GenericInfo />
            )}
          </div>
          {!isMobile && (
            <div>
              <PoweredByIwoca whiteLogo={whiteIwocaLogo} />
              <TrustPilot theme={trustPilotTheme} />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default SidePanel;
